import { Carousel, Image } from "react-bootstrap";

export default function ImageCarousel() {
    return (
        <Carousel controls={false} indicators={false}>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1770728193/Constellation/Courses/FirstAid/RealDefib_putwaz.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756807200/Constellation/Courses/FirstAid/bls2_nfbhrv_ud81jr.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756806047/Constellation/Courses/FirstAid/Pead1Day_epd0b2_udhbbo.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756806637/Constellation/Courses/FirstAid/FAW_p9srhv_igbz61.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756806638/Constellation/Courses/FirstAid/3FAW_gx3lax_etoei9.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756805935/Constellation/Courses/FAMH/MHFA_gxvf4b_ciotvn.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756806048/Constellation/Courses/FirstAid/Pead2Day_wktam9_mpczdd.jpg" fluid></Image>
            </Carousel.Item>
            <Carousel.Item>
                <Image src="https://res.cloudinary.com/du1edxnyy/image/upload/v1756806132/Constellation/Courses/H-S/FM_181197275_aqsbrc_skzuas.jpg" fluid></Image>
            </Carousel.Item>
        </Carousel>
    );
}
